import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Link from "next/link";
import Image from "next/image";

export default function Header2() {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Box>
      <AppBar sx={{ position: "fixed" }} color="inherit">
        <Box
          sx={{
            boxShadow: { xs: 3, sm: 0 },
            background: "inherit",
            width: "100%",
            zIndex: 100,
          }}
        >
          <Container>
            <Toolbar>
              <Link href="/">
                <Image
                  alt="econut-logo"
                  src="/static/images/econut-logo1.png"
                  width={isMobile ? 90 : 160}
                  height={isMobile ? 25 : 40}
                  objectFit="contain"
                  style={{ cursor: "pointer" }}
                />
              </Link>
            </Toolbar>
          </Container>
        </Box>
      </AppBar>
    </Box>
  );
}
